import { render, staticRenderFns } from "./TheSignatureConfirmation.vue?vue&type=template&id=f45ce1ce&scoped=true&"
import script from "./TheSignatureConfirmation.vue?vue&type=script&lang=js&"
export * from "./TheSignatureConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./TheSignatureConfirmation.vue?vue&type=style&index=0&id=f45ce1ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45ce1ce",
  null
  
)

export default component.exports